import { expenseServiceApi } from "../../app/expenseServiceApi";
import { API_URL } from "../../constants/apiUrl";
import {
  GetDashboardExpenseParams,
  GetDashboardExpenseResponseType,
  GetExpenseDetailsParams,
  GetExpenseDetailsResponseType,
  GetExpenseParams,
  GetExpenseResponseType,
  GetQueryArgsType,
  PatchQueryArgsType,
  PostQueryArgsType,
} from "../../types";

export const expenseApi = expenseServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    expenseEmployee: builder.query<
      GetExpenseResponseType,
      GetQueryArgsType<GetExpenseParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.expenseEmployee,
        ...queryArgs,
      }),
      providesTags: ["ExpenseEmployee"],
    }),
    expenseMonthlyDetails: builder.query<
      GetExpenseDetailsResponseType,
      GetQueryArgsType<GetExpenseDetailsParams>
    >({
      query: (args) => ({
        url: API_URL.expenseMonthlyDetails,
        ...args,
      }),
      providesTags: ["ExpenseMonthlyDetails"],
    }),
    createExpense: builder.mutation<unknown, PostQueryArgsType>({
      query: ({ body }) => ({
        url: `${API_URL.createExpense}`,
        method: "POST",
        body,
      }),
      invalidatesTags: (result) => {
        if (result) return ["ExpenseEmployee", "ExpenseMonthlyDetails"];

        return [];
      },
    }),
    expenseUpdate: builder.mutation<unknown, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.expenseUpdate}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result) => {
        if (result) return ["ExpenseEmployee", "ExpenseMonthlyDetails"];

        return [];
      },
    }),
    expenseAccept: builder.mutation<unknown, number>({
      query: (id) => ({
        url: `${API_URL.expenseAccept}/${id}`,
        method: "PATCH",
      }),
      invalidatesTags: (result) => {
        if (result) return ["ExpenseEmployee", "ExpenseMonthlyDetails"];

        return [];
      },
    }),
    expenseReject: builder.mutation<unknown, number>({
      query: (id) => ({
        url: `${API_URL.expenseReject}/${id}`,
        method: "PATCH",
      }),
      invalidatesTags: (result) => {
        if (result) return ["ExpenseEmployee", "ExpenseMonthlyDetails"];

        return [];
      },
    }),
    downloadEmployeeExpense: builder.query<
      void,
      GetQueryArgsType<GetExpenseDetailsParams>
    >({
      query: (queryArgs) => ({
        url: `${API_URL.downloadEmployeeExpense}`,
        responseHandler: async (response: any) => {
          const blob = await response.blob(); // Convert response to blob
          return window.URL.createObjectURL(blob); // Create object URL
        },
        cache: "no-cache",
        ...queryArgs,
      }),
    }),
    getDashboardExpense: builder.query<
      GetDashboardExpenseResponseType,
      GetQueryArgsType<GetDashboardExpenseParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getDashboardExpense,
        ...queryArgs,
      }),
    }),
  }),
});

export const {
  useExpenseEmployeeQuery,
  useExpenseMonthlyDetailsQuery,
  useCreateExpenseMutation,
  useExpenseUpdateMutation,
  useExpenseAcceptMutation,
  useExpenseRejectMutation,
  useLazyDownloadEmployeeExpenseQuery,
  useGetDashboardExpenseQuery,
} = expenseApi;
